import React, { useState, useEffect, memo  } from 'react'
import { Modal } from 'react-bootstrap'
import Toggle from 'react-toggle'
import moment from 'moment'
import { toastr } from 'react-redux-toastr';
import _ from 'lodash'
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import momenttz from '../../helpers/momenttz'
import { formatWithZoneAbbr } from '../../helpers/timeDisplaySettings'
import SnapshotChannelNode from './SnapshotChannelNode'
import ModalRequestContextVideo from './ModalRequestContextVideo'
import CustomButton from '../../CustomButton'
import EventFeedback from '../../EventFeedback'
import Controls from '../../Controls'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"

import { isCustomUserPermissions, isChannelAccessible, filterUrlsByChannelsAccess, CHANNELS_LIST } from '../../helpers/helperUsers'
import { getAccessibleSnapshotChannel } from '../../helpers/helperEvents'
import { getEventSnapshots, requestEventVideo } from '../../../../../shared/api/action/AlertActions'

import './EventViewSnapshotModal.sass'

const EventViewSnapshotModal = (props) => {
	const { event, getFleetEvents, onHide, user, company, tripSnapshots, toggleLoader, allowDeviceTz } = props;
	const displayTz = allowDeviceTz ? event?.device_tz : undefined;
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'homePage.vehicleSidebar.eventViewSnapshotModal' });
	const { roles, permissions } = user;
	const userRole = user.roles[0];
	const userPermissions = user.permissions;
	const eventId = event && (event.id || event.event_id);
	const canEventFeedbackView = eventId && (['system_admin', 'customer_service', 'sales_demo', 'partner', 'fleet_manager'].includes(userRole)
		|| (['custom_user', 'custom_partner'].includes(userRole) && isCustomUserPermissions(userRole, userPermissions, 'event_feedback_add'))
		|| (['custom_user', 'custom_partner'].includes(userRole) && isCustomUserPermissions(userRole, userPermissions, 'event_feedback_edit')))

	const [channel, setChannel] = useState(1)
	const [snapshots, setSnapshots] = useState([]) // stores snapshots from the snapshots_urls array response of the /events/[EVENT ID]/snapshots API
	const [snapshotsMultiple, setSnapshotsMultiple] = useState(null) // FWSD-7611, stores multiple snapshots if event_type=SNAPSHOTS_CLIP and the /events/[EVENT ID]/snapshots APPI returns snapshots object
	const [currentSnapshot, setCurrentSnapshot] = useState(null) // FWSD-7611, current selected snapshot displayed in img
	const [channels, setChannels] = useState([])
	const [showRequestContextVideo, setShowRequestContextVideo] = useState(false)
	const [showCalibrationBox, setShowCalibrationBox] = useState(false)
	const [showAdasCalibrationBox, setShowAdasCalibrationBox] = useState(false)
	const [showZoomControls, setShowZoomControls] = useState(false)
	// const canEventFeedbackView = ['system_admin', 'customer_service', 'sales_demo', 'partner'].includes(userRole)
	// 	|| isCustomUserPermissions(userRole, userPermissions, 'event_feedback_add')
	// 	|| isCustomUserPermissions(userRole, userPermissions, 'event_feedback_edit')

	const hasSnapshot = (channelNumber) => getAccessibleSnapshotChannel(event || tripSnapshots, user, [channelNumber])

	useEffect(() => {
		const accessibleChannels = CHANNELS_LIST.filter(hasSnapshot)
		let channel = accessibleChannels[0] || 0

		if (event && hasSnapshot(2) && ['External Driver', 'Driver', 'Drowsiness', 'Distraction', 'Phone Use', 'Custom Alert Distraction', 'Custom Alert Drowsiness', 'Custom Alert Phone Use', 'CameraBlock', 'Drowsiness/Head Down', 'Phone Use/Hand to Head', 'Yawning', 'Seatbelt', 'Smoking', 'Potential Ch2 Obstruction'].includes(event.type)) {
			channel = 2;
		}

		setChannel(channel);
		setChannels(CHANNELS_LIST.map(channelNumber => accessibleChannels.includes(channelNumber)));

		if (event) {
			viewSnapshot();
		} else if (tripSnapshots) {
			const snapshots = accessibleChannels.map(channelNumber => tripSnapshots[`snapshot_${channelNumber}`])
			setSnapshots(snapshots);

			const snapshot = document.getElementById('event-snapshot')
			snapshot.src = snapshots[0]

			// const snapshot = document.getElementById('event-snapshot');
			// if (event.snapshot_2 && (['External Driver', 'Driver', 'Drowsiness', 'Distraction', 'Phone Use', 'Custom Alert Distraction', 'Custom Alert Drowsiness', 'Custom Alert Phone Use'].indexOf(event.type) > -1)) {
			// 	snapshot.src = event.snapshot_2;
			// }
			// else {
			// 	snapshot.src = snapshots[0]
			// }
		}
	}, [])

	useEffect(() => {
		if (showZoomControls) {
			$(document).mouseup((e) => { if (($('.vjs-zoom__container')[0] && !$('.vjs-zoom__container')[0].contains(e.target)) && !$('.btn-zoom')[0].contains(e.target)) { setShowZoomControls(false) } });
		}
	}, [showZoomControls])

	const viewSnapshot = () => {
		toggleLoader(true);

		const data = {
			user_role: user.roles[0],
			event_id: eventId,
			company_name: company.name,
			partner_name: company.partner,
		}
		getEventSnapshots(data)
			.then((res, err) => {
				toggleLoader(false);

				if (res.data.response.error) {
					toastr.error(i18n.t('errorMessage.errDescription'));
				} else {
					const snapshots_urls = filterUrlsByChannelsAccess(user, res.data.response.snapshots_urls)
					const snapshots = res.data.response.snapshots
						? _.pickBy(res.data.response.snapshots, (value, key) => isChannelAccessible(user, key))
						: res.data.response.snapshots
					setSnapshots(snapshots_urls)
					setSnapshotsMultiple(_.isEmpty(snapshots) ? null : snapshots)

					// if event_type='SNAPSHOTS_CLIP'
					if (!_.isEmpty(snapshots)) {
						// takes the first image and assigns to currentSnapshot
						const firstAvailableChannel = +Object.keys(snapshots)[0]
						setChannel(firstAvailableChannel)
						setCurrentSnapshot(snapshots[firstAvailableChannel][0].image_src)
					}
					else {
						const snapshot = document.getElementById('event-snapshot');
						if (hasSnapshot(2) && ['External Driver', 'Driver', 'Drowsiness', 'Distraction', 'Phone Use', 'Custom Alert Distraction', 'Custom Alert Drowsiness', 'Custom Alert Phone Use', 'CameraBlock', 'Drowsiness/Head Down', 'Phone Use/Hand to Head', 'Yawning', 'Seatbelt', 'Smoking', 'Potential Ch2 Obstruction'].includes(event.type)) {
							snapshot.src = event.snapshot_2;
						}
						else {
							snapshot.src = snapshots_urls[0] || '';
						}
					}
				}
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('!getEventSnapshots error: ', error.response, error);
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response?.data?.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const changeChannel = (argChannel) => {
		if (argChannel === channel) return;

		setChannel(argChannel);
		setShowZoomControls(false);

		const snapshot = document.getElementById('event-snapshot')

		const re = RegExp('\/' + argChannel + '.jpeg?', 'i')
		const re1 = RegExp('\_' + argChannel + '.jpeg?', 'i')
		snapshots.forEach((item) => {
			if (item.search(re) > -1 || item.search(re1) > -1) {
				snapshot.src = item
			}
		})

		// snapshot.src = snapshots[channel-1]
	}

	const openRequestContextVideo = () => {
		setShowRequestContextVideo(true);
	}

	const closeRequestContextVideo = () => {
		setShowRequestContextVideo(false);
	}

	// FWSD-4740, create custom clip for the trip snapshots from the Homepage
	const createCustomClip = (e) => {
		e.preventDefault()

		const params = {
			device_id: tripSnapshots.device_id,
			start_ts: moment(tripSnapshots.timestamp).add(-5, 'seconds').format('YYYYMMDDHHmmss'),
			end_ts: moment(tripSnapshots.timestamp).add(5, 'seconds').format('YYYYMMDDHHmmss'),
		}
		toggleLoader(true);
		requestEventVideo(params)
			.then((res, err) => {
				toggleLoader(false);
				console.log('requestCustomVideo res, err: ', res, err);

				toastr.success('', i18n.t('toastMessage.toastrSuccessCVR'));
			})
			.catch((error) => {
				toggleLoader(false);
				console.log('requestCustomVideo error: ', error.response, error);
				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription)
			});
	}

	const channelsList = () => {
		const options = []
		for (let i = 0; i < 4; i++) {
			if (channels[i]) {
				const index = i + 1
				options[i] = <SnapshotChannelNode
					key={index}
					index={index}
					activechannel={channel}
					changeChannel={changeChannel}
				/>
			}
		}

		return (
			<>
				<ul className="list-inline chanels-list" >
					{options}
				</ul>

				{channel === 1 &&
					<label>
						<span className="toggle-left-title">{t('showADASBox')}</span>
						<Toggle
							icons={false}
							checked={showAdasCalibrationBox || false}
							onChange={() => setShowAdasCalibrationBox(!showAdasCalibrationBox)}
						/>
					</label>
				}
				{channel === 2 &&
					<label>
						<span className="toggle-left-title">{t('showDMSBox')}</span>
						<Toggle
							icons={false}
							checked={showCalibrationBox || false}
							onChange={() => setShowCalibrationBox(!showCalibrationBox)}
						/>
					</label>
				}

				<div className={channel === 2 ? "flexRow" : ""}>
					<CustomButton
						variant="link"
						style={{ textDecorationLine: 'none' }}
						prefix="btn-zoom"
						onClick={() => setShowZoomControls(!showZoomControls)}
					>
						{t('btnZoom')}
					</CustomButton>

					{!(['custom_user', 'custom_partner'].includes(roles[0]) && _.find(permissions, { 'perm_category_id': 2, 'a_edit': false })) && (
						<>
							{event
								? (
									<CustomButton
										variant="primary-outline"
										title={t('btnRequestAdditionalVideo')}
										prefix="btn-request-video"
										style={{ margin: 0 }}
										disabled={event?.uploading_status === 'EVENT_REPORTED'}
										onClick={openRequestContextVideo}
									>
										{t('btnRequestAdditionalVideo')}
									</CustomButton>
								)
								: (
									<CustomButton
										variant="primary-outline"
										title={t('btnRequestVideo')}
										style={{ margin: 0 }}
										onClick={createCustomClip}
									>
										{t('btnRequestVideo')}
									</CustomButton>
								)
							}
						</>
					)}
				</div>
			</>
		)
	}

	const changeSnapshotMultiple = (channelNumber, snapshotURL) => {
		setChannel(channelNumber)
		setCurrentSnapshot(snapshotURL)
	}

	const getCurrentSnapshotMultipleItem = () => {
		if (!snapshotsMultiple || !currentSnapshot) return null

		const snapshotItems = Object.values(snapshotsMultiple).reduce((acc, items) => [...acc, ...items], [])
		return snapshotItems.find(item => item.image_src === currentSnapshot)
	}

	const snapshotsMultipleHeader = () => {
		const currentSnapshotItem = getCurrentSnapshotMultipleItem()
		const vehicleName = event?.vehicle_name || event?.vehicle || event?.name || 'N/A'
		const deviceId = event?.device_id || event?.event_device_id || ''
		const timestamp = event?.timestamp || currentSnapshotItem?.timestamp
		const eventType = event?.event_type || 'SNAPSHOTS_CLIP'
		const eventId = event?.id || event?.event_id

		return (
			<div className="snapshots-clip-header">
				<div className="snapshots-clip-top">
					<div className="snapshots-clip-asset">
						<div>
							<div className="snapshots-clip-vehicle">
								{vehicleName}
								{deviceId && ` (Device ID: ${deviceId})`}
							</div>
							{timestamp && (
								<div className="snapshots-clip-date">
									{formatWithZoneAbbr(momenttz(`${timestamp}+00`, displayTz), 'M/D/YYYY h:mm:ss A')}
								</div>
							)}
						</div>
					</div>
					<div className="snapshots-clip-event">
						{canEventFeedbackView &&
							<EventFeedback
								event={event}
								getFleetEvents={getFleetEvents}
							/>
						}
						<div>
							<div className="snapshots-clip-type">{eventType}</div>
							{eventId && <div className="snapshots-clip-id">Event ID: {eventId}</div>}
						</div>
						<button
							type="button"
							className="btn-close"
							onClick={onHide}
							aria-label="Close"
						>
							&times;
						</button>
					</div>
				</div>
				{channelSnapshotsMap()}
			</div>
		)
	}

	const channelSnapshotsMap = () => {
		const availableChannels = Object.keys(snapshotsMultiple).map(Number).sort((a, b) => a - b)

		return (
			<div className="snapshots-channel-map">
				{
					availableChannels.map((channelNumber) => (
						<div className="snapshots-channel-row" key={channelNumber}>
							<div className="snapshots-channel-label">CH {channelNumber}</div>
							<div className="snapshots-channel-strip">
								{
									snapshotsMultiple[channelNumber].map((item, index) => (
										<button
											type="button"
											key={`${channelNumber}-${index}`}
											className={`snapshot-channel-thumb${channelNumber === channel && item.image_src === currentSnapshot ? ' active' : ''}`}
											onClick={() => changeSnapshotMultiple(channelNumber, item.image_src)}
											title={formatWithZoneAbbr(momenttz(`${item.timestamp}+00`, displayTz), 'h:mm:ss a')}
										>
											<img src={item.image_src} alt={`Channel ${channelNumber}`} />
										</button>
									))
								}
							</div>
						</div>
					))
				}
			</div>
		)
	}

	const element = document.getElementById('event-snapshot');
	const style = { bottom: '1rem', right: '1rem' };
	const isSnapshotsMultiple = snapshotsMultiple

	return (
		<Modal
			// size={`${isSnapshotsMultiple ? 'super-' : ''}lg`}
			size={`lg`}
			show
			onHide={onHide}
			// onEnter={onEnterModal}
			dialogClassName="event-snapshots-modal"
			aria-labelledby="contained-modal-title-lg "
		>
			{!isSnapshotsMultiple &&
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-lg">
						<span style={{ marginRight: '15px' }}>{t('titleSnapshots')}</span>
						{canEventFeedbackView &&
							<EventFeedback
								event={event}
								getFleetEvents={getFleetEvents}
							/>
						}
					</Modal.Title>
				</Modal.Header>
			}
			<Modal.Body>
				{isSnapshotsMultiple
					? (
						<>
							{snapshotsMultipleHeader()}
							<div className="snapshots-main-view">
								{currentSnapshot
									? (
										<>
											<div className="snapshots-active-channel">Channel {channel}</div>
											<img alt="" src={currentSnapshot} />
										</>
									)
									: <div className="snapshots-empty">{t('textNoSnapshotAvailable')}</div>
								}
							</div>
						</>
					)
					: (
						<div>
							<TransformWrapper>
								<Controls
									element={element}
									style={style}
									changeChannel={channel}
									showZoomControls={showZoomControls}
								/>
								<TransformComponent>
									<img width="100%" id="event-snapshot" alt="" />
								</TransformComponent>
							</TransformWrapper>
							{channel === 1 && showAdasCalibrationBox && (
								<div className="calibration-box-adas">
									<div className="mibble-calibration-bar" />
									<div className="middle-calibration-line" />
									<div className="bottom-calibration-bar" />
								</div>
							)}
							{channel === 2 && showCalibrationBox && <div className="calibration-box" />}
						</div>
					)
				}
			</Modal.Body>
			{!isSnapshotsMultiple &&
				<Modal.Footer className='flex-center' style={{ padding: 0, margin: "0 16px 16px", display: "flex", justifyContent: "space-between" }}>
					{channelsList()}
				</Modal.Footer>
			}

			{showRequestContextVideo
				&& (
					<ModalRequestContextVideo
						event={event}
						onHide={closeRequestContextVideo}
					/>
				)}
		</Modal>
	);
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company
	}),
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	}),
)(memo(EventViewSnapshotModal));
